exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#discount-codes .search-bar-container{height:2.125rem}#discount-codes .search-bar-container .search-bar{flex-grow:.3}#discount-codes .search-bar-container .search-by{min-width:8.25rem}#discount-codes .tab-element{padding:0 1.5rem;line-height:2rem;font-size:.875rem}", ""]);

// exports
